// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const PublicStatusListingRoot = styled.div`
  position: fixed;
  right: 1.5rem;
  bottom: 1.5rem;
  z-index: 2;
`;
